import { useTranslation } from "react-i18next";

export const useDayList = (total: number) => {
    const { t } = useTranslation();
    const dayList = [
        {
            value: 1,
            label: t("dayList.monday") || "Monday",
            isActive: false,
        },
        {
            value: 2,
            label: t("dayList.tuesday") || "Tuesday",
            isActive: false,
        },
        {
            value: 4,
            label: t("dayList.wednesday") || "Wednesday",
            isActive: false,
        },
        {
            value: 8,
            label: t("dayList.thursday") || "Thursday",
            isActive: false,
        },
        {
            value: 16,
            label: t("dayList.friday") || "Friday",
            isActive: false,
        },
        {
            value: 32,
            label: t("dayList.saturday") || "Saturday",
            isActive: false,
        },
        {
            value: 64,
            label: t("dayList.sunday") || "Sunday",
            isActive: false,
        },
    ];

    for (let i = 6; i >= 0; i--) {
        if (total >= dayList[i].value) {
            dayList[i].isActive = true;
            total -= dayList[i].value;
        }
        if (total === 0) break;
    }

    return [...dayList];
};
